import { render, staticRenderFns } from "./ModelManagement.vue?vue&type=template&id=a5e7cb1e&scoped=true"
import script from "./ModelManagement.vue?vue&type=script&lang=js"
export * from "./ModelManagement.vue?vue&type=script&lang=js"
import style0 from "./ModelManagement.vue?vue&type=style&index=0&id=a5e7cb1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e7cb1e",
  null
  
)

export default component.exports